import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import FinnLogo from "../assets/finn-dark-star.svg";
import { pageStyles } from "./theme";

export default function PageShell({
  children,
  wide = false,
  topAligned = false,
  footer,
}) {
  return (
    <Box sx={pageStyles.container}>
      <Container component="main" maxWidth={wide ? "md" : "sm"}>
        <Box
          sx={{
            ...pageStyles.centerWrapper,
            ...(topAligned ? { justifyContent: "flex-start" } : {}),
          }}
        >
          <Box sx={{ mb: { xs: 2.5, sm: 3.5 } }}>
            <img src={FinnLogo} alt="Finn" style={pageStyles.logo} />
          </Box>
          <Box sx={{ ...pageStyles.card, ...(wide ? pageStyles.wideCard : {}) }}>
            {children}
          </Box>
          {footer ? <Box sx={{ mt: 3 }}>{footer}</Box> : null}
        </Box>
      </Container>
    </Box>
  );
}
